<template>
  <a-modal title="编辑规则" :width="700" :visible="visible" @ok="handleOk" @cancel="handleCancel">
    <a-form-model
      ref="ruleForm"
      :labelCol="{ span: 4 }"
      :wrapperCol="{ span: 18 }"
      :model="form"
      :rules="rules"
    >
      <a-form-model-item label="指标项" prop="pointId">
        <a-tree-select
          v-model="form.pointId"
          style="width: 100%"
          :tree-data="treeData.indexIetmTree"
          search-placeholder="请选择指标项"
        />
      </a-form-model-item>
      <a-form-model-item label="规则名称" prop="name">
        <a-input v-model="form.name" allowClear />
      </a-form-model-item>
      <a-form-model-item label="题目" prop="questionIds">
        <a-tree-select
          v-model="form.questionIds"
          style="width: 100%; max-height: 210px; overflow-y: auto"
          :dropdownStyle="{ maxHeight: '210px' }"
          :tree-data="treeData.topicTree"
          tree-checkable
          :show-checked-strategy="SHOW_PARENT"
          search-placeholder="请选择题目"
        />
      </a-form-model-item>
      <a-form-model-item label="计算方式" prop="type">
        <a-select v-model="form.type">
          <a-select-option :value="1">合计</a-select-option>
          <a-select-option :value="2">其中一项</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="规则" prop="maxScore">
        <a-input-group compact>
          <a-input-number
            style="width: 100px; text-align: center"
            placeholder="最小值"
            v-model="form.minScore"
          />
          <a-input
            style="width: 30px; border-left: 0; pointer-events: none; background: #fff"
            placeholder="~"
            disabled
          />
          <a-input-number
            style="width: 100px; text-align: center; border-left: 0"
            placeholder="最大值"
            v-model="form.maxScore"
          />
        </a-input-group>
      </a-form-model-item>
      <a-form-model-item label="结果分析">
        <!--        <a-textarea-->
        <!--          v-model="form.resultAnalysis"-->
        <!--          :rows="3"-->
        <!--          placeholder="请输入结果分析"-->
        <!--          allowClear-->
        <!--        />-->
        <a-button type="primary" @click="openRichTextModal('resultAnalysis')">
          结果分析 - 富文本编辑
        </a-button>
      </a-form-model-item>
      <a-form-model-item label="建议">
        <!--        <a-textarea v-model="form.suggestion" :rows="3" placeholder="请输入建议" allowClear />-->
        <a-button type="primary" @click="openRichTextModal('suggestion')">
          建议 - 富文本编辑
        </a-button>
      </a-form-model-item>
    </a-form-model>
    <!--    富文本编辑器-->
    <InventoryRichModal ref="InventoryRichModalRef" @handleOk="richTextHandleOk" />
  </a-modal>
</template>

<script>
import { TreeSelect } from 'ant-design-vue'
import { putAction } from '@/api/manage'
import InventoryRichModal from './InventoryRichModal'

const SHOW_PARENT = TreeSelect.SHOW_PARENT
export default {
  name: 'EditRuleModal',
  components: { InventoryRichModal },
  props: {
    treeData: {
      type: Object,
      default: () => {},
    },
    evaluationId: {
      type: String,
      default: 0,
    },
  },
  data() {
    return {
      visible: false,
      form: {},
      rules: {
        name: [{ required: true, message: '规则名称不能为空', trigger: 'blur' }],
        type: [{ required: true, message: '计算类型不能为空', trigger: 'blur' }],
        pointId: [{ required: true, message: '指标项不能为空', trigger: 'blur' }],
        questionIds: [{ required: true, message: '题目不能为空', trigger: 'blur' }],
        maxScore: [{ required: true, message: '规则最小/最大值不能为空', trigger: 'blur' }],
      },
      SHOW_PARENT,
    }
  },
  created() {},
  methods: {
    showModal(data) {
      console.log('编辑信息：', data)
      this.form = {
        id: data.id,
        pointId: data.pointId.split(','),
        name: data.name,
        questionIds: data.questionIds.split(','),
        type: data.type,
        minScore: data.minScore,
        maxScore: data.maxScore,
        resultAnalysis: data.resultAnalysis,
        suggestion: data.suggestion,
      }
      this.visible = true
    },
    hideModal() {
      this.visible = false
      this.form = {}
    },
    handleOk() {
      this.$refs.ruleForm.validate((valid) => {
        if (!valid) return

        let questionIds = ''
        if (this.form.questionIds.includes('all')) {
          questionIds = this.treeData.topicTree[0].children.map((item) => item.value).join(',')
        } else {
          questionIds = this.form.questionIds.join(',')
        }

        const params = {
          ...this.form,
          pointId: this.form.pointId.join(','),
          questionIds: questionIds,
          evaluationId: this.evaluationId,
        }

        console.log('参数信息：', params)
        putAction('/schoolEvaluationRule/edit', params).then((res) => {
          if (res.success) {
            this.$message.success('编辑成功')
            this.$emit('updateTable')
            this.hideModal()
          }
        })
      })
    },
    handleCancel() {
      this.hideModal()
    },
    openRichTextModal(field) {
      const richMapObj = {
        resultAnalysis: '结果分析',
        suggestion: '建议',
      }
      const data = {
        title: richMapObj[field],
        content: this.form[field],
        field,
        isEdit: true,
      }
      this.$refs.InventoryRichModalRef.show(data)
    },
    richTextHandleOk(record) {
      console.log('编辑记录：', record)
      this.$set(this.form, record.field, record.content)
    },
  },
}
</script>
<style scoped lang="less"></style>
